var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},React.createElement("g",{"stroke":"#333333"},React.createElement("g",{"transform":"translate(3.000000, 3.000000)"},[React.createElement("circle",{"fill":"#FFFFFF","cx":"9","cy":"9","r":"9","key":0}),React.createElement("g",{"transform":"translate(5.000000, 5.000000)","fill":"#DDDDDD","key":1},[React.createElement("path",{"d":"M8,8 L0,0 L8,8 Z","key":0}),React.createElement("path",{"d":"M8,8 L0,0 L8,8 Z","transform":"translate(4.000000, 4.000000) scale(-1, 1) translate(-4.000000, -4.000000) ","key":1})])]))));
}

Close.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24"};

module.exports = Close;

Close.default = Close;
